import { Type, type SchemaOptions } from '@sinclair/typebox';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_VOUCHER_TYPE = 'VOUCHER_TYPE_';

//⚠️IMPACT attention changer dans le fichier prisma l'enum voucher_type
export enum VoucherType {
  PACK = 'PACK',
  PRESTATION = 'PRESTATION',
  AMOUNT = 'AMOUNT',
}

export const VoucherTypeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_VOUCHER_TYPE}${VoucherType.PACK}`]: 'Pack',
    [`${TRANSLATE_KEY_VOUCHER_TYPE}${VoucherType.PRESTATION}`]: 'Prestation',
    [`${TRANSLATE_KEY_VOUCHER_TYPE}${VoucherType.AMOUNT}`]: 'Montant',
  },
};

validateEnumTranslations(VoucherType, VoucherTypeTranslation, TRANSLATE_KEY_VOUCHER_TYPE, true);

export const VoucherTypeSchema = (options?: SchemaOptions) => {
  return Type.Union(
    Object.values(VoucherType).map((value) =>
      Type.Literal(value, {
        label: `${TRANSLATE_KEY_VOUCHER_TYPE}${value}`,
      }),
    ),
    options,
  );
};

export const TRANSLATE_KEY_VOUCHER_STATUS = 'VOUCHER_STATUS_';

//⚠️IMPACT attention changer dans le fichier prisma l'enum voucher_status
export enum VoucherStatus {
  WAITING_PAYMENT = 'WAITING_PAYMENT',
  ACTIVE = 'ACTIVE',
  PARTIALLY_USED = 'PARTIALLY_USED',
  FULLY_USED = 'FULLY_USED',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED',
}

export const VoucherStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_VOUCHER_STATUS}${VoucherStatus.WAITING_PAYMENT}`]: 'En attente de paiement',
    [`${TRANSLATE_KEY_VOUCHER_STATUS}${VoucherStatus.ACTIVE}`]: 'Active',
    [`${TRANSLATE_KEY_VOUCHER_STATUS}${VoucherStatus.PARTIALLY_USED}`]: 'Partiellement utilisée',
    [`${TRANSLATE_KEY_VOUCHER_STATUS}${VoucherStatus.FULLY_USED}`]: 'Épuisée',
    [`${TRANSLATE_KEY_VOUCHER_STATUS}${VoucherStatus.EXPIRED}`]: 'Expirée',
    [`${TRANSLATE_KEY_VOUCHER_STATUS}${VoucherStatus.CANCELLED}`]: 'Annulée',
  },
};

validateEnumTranslations(VoucherStatus, VoucherStatusTranslation, TRANSLATE_KEY_VOUCHER_STATUS, true);

export const VoucherStatusSchema = (options?: SchemaOptions) => {
  return Type.Union(
    Object.values(VoucherStatus).map((value) =>
      Type.Literal(value, {
        label: `${TRANSLATE_KEY_VOUCHER_STATUS}${value}`,
      }),
    ),
    options,
  );
};

export const TRANSLATE_KEY_VOUCHER_UNUSABLE_REASON = 'VOUCHER_UNUSABLE_REASON_';

/**
 * Motif pour lequel un bon n'est plus utilisable (`getVoucherUnusableReason`). Pas d'enum Prisma :
 * valeur calculée à la volée, jamais stockée.
 */
export enum VoucherUnusableReason {
  WAITING_PAYMENT = 'WAITING_PAYMENT',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  FULLY_USED = 'FULLY_USED',
}

export const VoucherUnusableReasonTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_VOUCHER_UNUSABLE_REASON}${VoucherUnusableReason.WAITING_PAYMENT}`]:
      "Ce coupon n'a pas encore été payé.",
    [`${TRANSLATE_KEY_VOUCHER_UNUSABLE_REASON}${VoucherUnusableReason.CANCELLED}`]: 'Ce coupon a été annulé.',
    [`${TRANSLATE_KEY_VOUCHER_UNUSABLE_REASON}${VoucherUnusableReason.EXPIRED}`]: 'Ce coupon est expiré.',
    [`${TRANSLATE_KEY_VOUCHER_UNUSABLE_REASON}${VoucherUnusableReason.FULLY_USED}`]:
      'Ce coupon est entièrement utilisé.',
  },
};

validateEnumTranslations(
  VoucherUnusableReason,
  VoucherUnusableReasonTranslation,
  TRANSLATE_KEY_VOUCHER_UNUSABLE_REASON,
  true,
);

export const VoucherUnusableReasonSchema = (options?: SchemaOptions) => {
  return Type.Union(
    Object.values(VoucherUnusableReason).map((value) =>
      Type.Literal(value, {
        label: `${TRANSLATE_KEY_VOUCHER_UNUSABLE_REASON}${value}`,
      }),
    ),
    options,
  );
};

export const TRANSLATE_KEY_VOUCHER_USAGE_SOURCE = 'VOUCHER_USAGE_SOURCE_';

//⚠️IMPACT attention changer dans le fichier prisma l'enum voucher_usage_source
export enum VoucherUsageSource {
  CUSTOMER_BOOKING = 'CUSTOMER_BOOKING',
  PRO_MANUAL = 'PRO_MANUAL',
}

export const VoucherUsageSourceTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_VOUCHER_USAGE_SOURCE}${VoucherUsageSource.CUSTOMER_BOOKING}`]: 'Réservation client',
    [`${TRANSLATE_KEY_VOUCHER_USAGE_SOURCE}${VoucherUsageSource.PRO_MANUAL}`]: 'Utilisation manuelle',
  },
};

validateEnumTranslations(VoucherUsageSource, VoucherUsageSourceTranslation, TRANSLATE_KEY_VOUCHER_USAGE_SOURCE, true);

export const VoucherUsageSourceSchema = (options?: SchemaOptions) => {
  return Type.Union(
    Object.values(VoucherUsageSource).map((value) =>
      Type.Literal(value, {
        label: `${TRANSLATE_KEY_VOUCHER_USAGE_SOURCE}${value}`,
      }),
    ),
    options,
  );
};

export const TRANSLATE_KEY_VOUCHER_USAGE_KIND = 'VOUCHER_USAGE_KIND_';

//⚠️IMPACT attention changer dans le fichier prisma l'enum voucher_usage_kind
export enum VoucherUsageKind {
  CONSUMPTION = 'CONSUMPTION',
  MANUAL_RECHARGE = 'MANUAL_RECHARGE',
}

export const VoucherUsageKindTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_VOUCHER_USAGE_KIND}${VoucherUsageKind.CONSUMPTION}`]: 'Utilisation',
    [`${TRANSLATE_KEY_VOUCHER_USAGE_KIND}${VoucherUsageKind.MANUAL_RECHARGE}`]: 'Recharge',
  },
};

validateEnumTranslations(VoucherUsageKind, VoucherUsageKindTranslation, TRANSLATE_KEY_VOUCHER_USAGE_KIND, true);

export const VoucherUsageKindSchema = (options?: SchemaOptions) => {
  return Type.Union(
    Object.values(VoucherUsageKind).map((value) =>
      Type.Literal(value, {
        label: `${TRANSLATE_KEY_VOUCHER_USAGE_KIND}${value}`,
      }),
    ),
    options,
  );
};
